/**
 * Session storage utilities for ProcFeeConfirm
 */

import { SESSION_KEY } from "constants/key";
import { CostSettingInfo } from "features/mst_proc_fee/types/proc-fee";
import { parseNumber } from "util/helper";

/**
 * Save cost settings to all relevant session storage keys
 * @param costSetting - The cost setting to save
 */
const saveCostSettingsToSession = (costSetting: CostSettingInfo): void => {
  // Build common data structures
  const procFeesData = {
    replac_labor_cost: {
      value: parseNumber(costSetting.replac_labor_cost),
      checked: true,
    },
    waste_tire_cost: {
      value: parseNumber(costSetting.waste_tire_cost),
      checked: costSetting.waste_tire_cost_flag,
    },
    rubber_stem_valve_cost: {
      value: parseNumber(costSetting.rubber_stem_valve_cost),
      checked: costSetting.rubber_stem_valve_flag,
    },
    nitrogen_inflation_cost: {
      value: parseNumber(costSetting.nitrogen_inflation_cost),
      checked: costSetting.nitrogen_inflation_flag,
    },
    hub_rust_prevention_cost: {
      value: parseNumber(costSetting.hub_rust_prevention_cost),
      checked: costSetting.hub_rust_prevention_flag,
    },
  };

  const cashbackData = {
    puncture: costSetting.tire_puncture_flag,
    cashback_period: costSetting.cashback_flag ? costSetting.cashback_period : 1,
  };

  const fastenersData = {
    nut: costSetting.nut,
    nut_flag: costSetting.nut_flag,
    lock_nut: costSetting.lock_nut,
    lock_nut_flag: costSetting.lock_nut_flag,
    hub_ring: costSetting.hub_ring,
    hub_ring_flag: costSetting.hub_ring_flag,
    wheel_coating: costSetting.wheel_coating,
    wheel_coating_flag: costSetting.wheel_coating_flag,
  };

  // Update SELECTED_TIRE
  try {
    const selectedTireDataRaw = sessionStorage.getItem(SESSION_KEY.SELECTED_TIRE);
    if (selectedTireDataRaw) {
      const selectedTireData = JSON.parse(selectedTireDataRaw);
      sessionStorage.setItem(
        SESSION_KEY.SELECTED_TIRE,
        JSON.stringify({
          ...selectedTireData,
          proc_fees: procFeesData,
          cashback: cashbackData,
        }),
      );
    }
  } catch (error) {
    // Silently handle error
  }

  // Update MST_PROC_WHEEL_FEE
  try {
    const mstProcWheelFeeRaw = sessionStorage.getItem(SESSION_KEY.MST_PROC_WHEEL_FEE);
    const mstProcWheelFee = mstProcWheelFeeRaw ? JSON.parse(mstProcWheelFeeRaw) : {};
    sessionStorage.setItem(
      SESSION_KEY.MST_PROC_WHEEL_FEE,
      JSON.stringify({
        ...mstProcWheelFee,
        proc_fees: procFeesData,
        cashback: cashbackData,
      }),
    );
  } catch (error) {
    // Silently handle error
  }

  // Update SELECTED_WHEEL
  try {
    const selectedWheelDataRaw = sessionStorage.getItem(SESSION_KEY.SELECTED_WHEEL);
    if (selectedWheelDataRaw) {
      const selectedWheelData = JSON.parse(selectedWheelDataRaw);
      sessionStorage.setItem(
        SESSION_KEY.SELECTED_WHEEL,
        JSON.stringify({
          ...selectedWheelData,
          cost_setting: costSetting,
        }),
      );
    }
  } catch (error) {
    // Silently handle error
  }

  // Update WHEEL_STORE_STATE
  try {
    const wheelStoreStateRaw = sessionStorage.getItem(SESSION_KEY.WHEEL_STORE_STATE);
    if (wheelStoreStateRaw) {
      const wheelStoreState = JSON.parse(wheelStoreStateRaw);
      sessionStorage.setItem(
        SESSION_KEY.WHEEL_STORE_STATE,
        JSON.stringify({
          ...wheelStoreState,
          fasteners: fastenersData,
        }),
      );
    }
  } catch (error) {
    // Silently handle error
  }
};

export default saveCostSettingsToSession;
